import { render, staticRenderFns } from "./report-customerdetail.vue?vue&type=template&id=bba315da&"
import script from "./report-customerdetail.vue?vue&type=script&lang=js&"
export * from "./report-customerdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports